import {
  ParagraphLines,
} from "@/ui/components/primitives/Skeleton/ParagraphLines";
import { FC } from "react";

export const OverviewEditCardSkeleton: FC = () => (
  <ParagraphLines />
);
